import React from 'react'
import { useParams } from "../util/router.js";
import firebase from '../util/firebase.js';
// import { useAuth } from '../util/auth.js';
import Container from "react-bootstrap/Container";
import Col from 'react-bootstrap/Col';
import Row from "react-bootstrap/Row";
import { useDocumentData } from 'react-firebase-hooks/firestore';
import PageLoader from './PageLoader.js'
import BigCard from './BigCard.js'

function CoffeePageSection(props) {
    const { coffeeId } = useParams();
    // const auth = useAuth();
    const coffeeDoc =  firebase.firestore().collection("coffee").doc(coffeeId);
    const [coffee, loading, error] = useDocumentData(coffeeDoc, { idField: 'id' });

    // const bookmarkRef = firebase.firestore().doc(`/coffee/${coffeeId}/saved/${firebase.auth().currentUser.uid}_${coffeeId}`);
    // const [bookmarkDoc] = useDocumentData(bookmarkRef);

    // const [bookmarkDoc, setBookmarkDoc] = useState(null);
    // const [ratingDoc, setRatingDoc] = useState(null);

    // useEffect(() => {
    //   const getSavedValue = async () => {
    //     //only perform if auth.user object is true (user logged in) - this line also prevents refresh from working
    //     if (auth.user) {
    //       const savedRef = firebase.firestore().doc(`/coffee/${coffeeId}/saved/${firebase.auth().currentUser.uid}_${coffeeId}`);
    //         await savedRef.onSnapshot(function(doc) {
    //         if (doc.exists) {
    //           setBookmarkDoc(true)
    //           console.log("Data pull on getSavedValue in SaveCoffee has run");
    //         } 
    //        })}
    //     };

    //     const getRatedValue = async () => {
    //       if (auth.user) {
    //       const ratedRef = firebase.firestore().doc(`/coffee/${coffeeId}/ratings/${firebase.auth().currentUser.uid}_${coffeeId}`);
    //         await ratedRef.onSnapshot(function(doc) {
    //         if (doc.exists) {
    //           //i turned off the below line about setRating and it it still worked in dashboard but not bigCard
    //           setRatingDoc(doc.data().ratingClicked);
    //           console.log("Data pull for your current rating in starRating has executed");
    //         }
    //       })}
    //     };

    //     getSavedValue();
    //     getRatedValue();
    //   // eslint-disable-next-line
    // }, []);
    
    

    return (
        <Container>

        {error && console.log(error)}
        {loading && <PageLoader />}

        <Row className="justify-content-center">
          <Col
          xs={12}
          md={8}
          lg={6}
          className="py-2 px-2 d-flex align-items-stretch"
          key={coffeeId}
         >

            {coffee && <BigCard coffee={coffee} />}

          </Col>

        </Row>

        </Container>        
    )
}

export default CoffeePageSection



